import { draftingContainer } from './domains';
import { disclosureContainer } from './domains/disclosure';
import { patentDraftContainer } from './domains/patent-draft';
import { prosecutionContainer } from './domains/prosecution';

export { default as DisclosureContainer } from './components/containers/DisclosureContainer.vue';
export { default as ProsecutionContainer } from './components/containers/ProsecutionContainer.vue';
export { default as PatentDraftContainer } from './components/containers/PatentDraftContainer.vue';

export const draftingContainers = [draftingContainer, disclosureContainer, patentDraftContainer, prosecutionContainer];
